// extracted by mini-css-extract-plugin
export default {"container":"styles_container__qRi3w","wrapper":"styles_wrapper__AVRtM","image":"styles_image__MoI1o","heading":"styles_heading__XLPK0","para":"styles_para__u1WNj"};